module.exports = __webpack_public_path__ + "static/the-city-we-became-67f5ca2a44d9ae23e717f439b20311d1.jpg";